import {skipToken} from '@reduxjs/toolkit/query';

import {useListFeatureQuery} from '@dms/api/new-vehicle';

import {useDebouncedValue} from 'shared/web';

const LIBRARY_SEARCH_DELAY_MS = 300;

/**
 * Searches the tenant library on the server; the library holds every model's items, so it is
 * read only for a typed term. `term` is expected trimmed.
 */
export function useFeatureLibrarySearch(term: string) {
  const search = useDebouncedValue(term, LIBRARY_SEARCH_DELAY_MS);
  const library = useListFeatureQuery(search ? {search} : skipToken);
  const isSearching = term.length > 0 && (term !== search || library.isFetching);
  return {
    features: term.length > 0 && !isSearching ? (library.currentData?.items ?? []) : [],
    isSearching,
  };
}
